import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 4C5 2.89543 5.89543 2 7 2H19.7574C20.2878 2 20.7965 2.21071 21.1716 2.58579L26.4142 7.82843C26.7893 8.2035 27 8.71221 27 9.24264V28C27 29.1046 26.1046 30 25 30H7C5.89543 30 5 29.1046 5 28V4Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
      <path d="M20 2V6C20 7.65685 21.3431 9 23 9H27" stroke="#0090FF" strokeWidth="2" />
      <rect opacity="0.5" x="10" y="19" width="9" height="2" rx="1" fill="#0090FF" />
      <rect opacity="0.5" x="10" y="23" width="12" height="2" rx="1" fill="#0090FF" />
    </svg>
  );
};

export default Svg;
